import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Bell, Mic, X } from 'lucide-react';
import { TaskCard } from './components/TaskCard';
const TASKS = [{
  id: '1',
  title: 'Pick up prescription from Boots by 3pm',
  avatar: 'https://i.pravatar.cc/150?u=1',
  name: 'Sarah J.',
  distance: '0.4 miles away',
  reward: '£15',
  urgency: 'Today',
  urgencyColor: 'bg-orange-500/10 text-orange-500',
  isExpanded: false
}, {
  id: '2',
  title: 'Help move a sofa down one flight of stairs',
  avatar: 'https://i.pravatar.cc/150?u=2',
  name: 'Marcus T.',
  distance: '1.2 miles away',
  reward: '£40',
  urgency: 'Now',
  urgencyColor: 'bg-red-500/10 text-red-500',
  isExpanded: true,
  trustScore: 4.9,
  completedTasks: 47
}, {
  id: '3',
  title: 'Drop off keys to my flatmate at the station',
  avatar: 'https://i.pravatar.cc/150?u=3',
  name: 'Emma W.',
  distance: '0.8 miles away',
  reward: '£10',
  urgency: '1hr',
  urgencyColor: 'bg-yellow-500/10 text-yellow-500',
  isExpanded: false
}];
const TABS = ['Nearby', 'Online', 'My Tasks'];
export function App() {
  const [activeTab, setActiveTab] = useState('Nearby');
  const [showNotification, setShowNotification] = useState(true);
  return <div className="min-h-screen bg-[#000000] flex justify-center w-full font-sans" data-id="element-0">
      <div className="w-full max-w-[440px] bg-[#070709] min-h-screen relative shadow-2xl overflow-hidden flex flex-col" data-id="element-1">
        {/* Top Bar */}
        <header className="sticky top-0 z-50 bg-[#070709]/80 backdrop-blur-md border-b border-[#1a1a24] pt-safe" data-id="element-2">
          <div className="flex items-center justify-between px-5 py-4" data-id="element-3">
            <div className="flex items-center gap-2" data-id="element-4">
              <div className="w-3 h-3 rounded-full bg-[#4ade80]" data-id="element-5" />
              <h1 className="text-xl font-bold text-white tracking-tight" data-id="element-6">
                TaskVerse
              </h1>
            </div>
            <button className="relative p-2 rounded-full hover:bg-[#1a1a24] transition-colors" data-id="element-7">
              <Bell className="w-6 h-6 text-white" data-id="element-8" />
              <span className="absolute top-1.5 right-1.5 w-2.5 h-2.5 bg-[#4ade80] rounded-full border-2 border-[#070709]" data-id="element-9" />
            </button>
          </div>

          {/* Tabs */}
          <div className="flex px-5 gap-6 pb-0 border-b border-[#1a1a24]" data-id="element-10">
            {TABS.map(tab => <button key={tab} onClick={() => setActiveTab(tab)} className={`relative pb-3 text-sm font-medium transition-colors ${activeTab === tab ? 'text-white' : 'text-[#a0a0ab]'}`} data-id="element-11">
                {tab}
                {activeTab === tab && <motion.div layoutId="activeTab" className="absolute bottom-0 left-0 right-0 h-0.5 bg-[#4ade80] rounded-t-full" data-id="element-12" />}
              </button>)}
          </div>
        </header>

        {/* Scrollable Content */}
        <main className="flex-1 overflow-y-auto no-scrollbar pb-24" data-id="element-13">
          {/* Notification Pill */}
          <AnimatePresence data-id="element-14">
            {showNotification && <motion.div initial={{
            opacity: 0,
            y: -20
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            scale: 0.95
          }} className="mx-5 mt-4 mb-2 bg-[#4ade80]/10 border border-[#4ade80]/20 rounded-full px-4 py-2.5 flex items-center justify-between" data-id="element-15">
                <div className="flex items-center gap-2" data-id="element-16">
                  <div className="w-2 h-2 rounded-full bg-[#4ade80] animate-pulse" data-id="element-17" />
                  <span className="text-sm font-medium text-[#4ade80]" data-id="element-18">
                    3 new tasks near you
                  </span>
                </div>
                <button onClick={() => setShowNotification(false)} className="text-[#4ade80]/60 hover:text-[#4ade80]" data-id="element-19">
                  <X className="w-4 h-4" data-id="element-20" />
                </button>
              </motion.div>}
          </AnimatePresence>

          {/* Feed */}
          <div className="px-5 py-4 flex flex-col gap-5" data-id="element-21">
            {TASKS.map(task => <TaskCard key={task.id} {...task} data-id="element-22" />)}
          </div>
        </main>

        {/* FAB */}
        <div className="absolute bottom-6 right-5 z-50 flex items-center gap-3" data-id="element-23">
          <span className="bg-[#1a1a24] text-white text-sm font-medium px-3 py-1.5 rounded-full shadow-lg border border-[#2a2a35] opacity-0 translate-x-4 transition-all duration-300 peer-hover:opacity-100 peer-hover:translate-x-0" data-id="element-24">
            Post a Need
          </span>
          <button className="peer relative w-16 h-16 bg-[#4ade80] rounded-full flex items-center justify-center shadow-[0_0_20px_rgba(74,222,128,0.3)] hover:scale-105 active:scale-95 transition-all" data-id="element-25">
            <div className="absolute inset-0 rounded-full border-2 border-[#4ade80] animate-ping opacity-20" data-id="element-26" />
            <Mic className="w-7 h-7 text-[#070709]" data-id="element-27" />
          </button>
        </div>
      </div>
    </div>;
}